









































































































































































































































import { Component, Vue, Prop } from "vue-property-decorator";
import QuestionImg from "@/components/question/question-img.vue";
import QuestionSelect from "@/components/question/question-select.vue";
import Empty from "@/components/empty.vue";
import { GetSizhenType, GetDanxiang, SaveDanxiang } from "@/request/common";
@Component({
  components: {
    QuestionImg,
    QuestionSelect,
    Empty,
  },
})
export default class Name extends Vue {
  private questionIndex: any = 0;
  private showAnswer: any = false;
  private ifShowResult: any = false;
  private tab: any = [];
  private data: any = [];
  private sizhenTab: any = [];
  private imgIndex: any = 0;
  private ifReading: any = false; // 脉图设备是否已存在
  private ifOpen: any = false; // 是否打开过脉的设备
  private get user() {
    return this.$store.state.user;
  }
  private get systemInfo() {
    return this.$store.state.systemInfo;
  }
  private async openPulse() {
    const option = this.data[this.questionIndex].options.find(
      (item: any) => item.value === this.data[this.questionIndex].correct
    );
    const val: any = option ? option.label : "";
    console.log(val, "control_hand", "start");
    const result = await window.electronMyAPI.changePulse(
      val,
      "control_hand",
      "start"
    );
  }
  private stopPulse() {
    if (this.systemInfo.SETTING.iFHasDevicePulse && this.ifReading) {
      console.log("停止", "control_hand", "stop");
      const result = window.electronMyAPI.changePulse(
        "停止",
        "control_hand",
        "stop"
      );
      console.log(result);
    }
  }
  private preview(url: any) {
    window.open(url);
  }
  // 是否显示选中的
  private ifSelect(item: any, val: any) {
    let result: any = false;
    if (
      (item.answer || item.answer === 0) &&
      (item["类型"] == "单选" || item["类型"] == "判断") &&
      item.answer === val.value
    ) {
      result = true;
    } else if (item["类型"] == "多选" && item.answer) {
      const index = item.answer.indexOf(val.value);
      if (index !== -1) {
        result = true;
      }
    }
    return result && this.data[this.questionIndex].ifShowAnswer;
  }
  // 是否显示正确答案
  private ifCorrectAnswer(items: any, item: any) {
    let correct = [];
    if (items["类型"] == "单选" || items["类型"] == "判断") {
      correct = [items.correct];
    } else if (items["类型"] == "多选") {
      correct = items.correct;
    }
    const inc = correct.findIndex((i: any) => {
      return i === item.value;
    });
    return this.data[this.questionIndex].ifShowCorrect && inc != -1;
  }
  // 是否答对
  private ifDadui(item: any, val: any) {
    // 是答案
    // 是正确答案
    let result: any = false;
    if (
      ((item["类型"] == "单选" || item["类型"] == "判断") &&
        item.answer === item.correct &&
        item.answer === val.value) ||
      (!item.correct && item.correct !== 0 && item.answer === val.value)
    ) {
      result = true;
    }
    if (item["类型"] == "多选" && item.answer && item.answer.length > 0) {
      if (!item.correct || item.correct.length == 0) {
        // 没有正确答案的选择也为正确
        const index1 = item.answer.indexOf(val.value);
        if (index1 !== -1) {
          result = true;
        }
      } else {
        const index1 = item.answer.indexOf(val.value);
        const index2 = item.correct.indexOf(val.value);
        if (index1 !== -1 && index2 !== -1) {
          result = true;
        }
      }
    }
    return result && this.data[this.questionIndex].ifShowAnswerResult;
  }
  // 是否答错
  private ifDacuo(item: any, val: any) {
    // 是答案
    // 不是正确答案
    let result: any = false;
    if (
      (item["类型"] == "单选" || item["类型"] == "判断") &&
      item.answer !== item.correct &&
      item.answer === val.value &&
      !(!item.correct && item.correct !== 0)
    ) {
      result = true;
    }
    if (
      item["类型"] == "多选" &&
      item.answer &&
      item.correct &&
      item.correct.length > 0
    ) {
      const index1 = item.answer.indexOf(val.value);
      const index2 = item.correct.indexOf(val.value);
      if (index1 !== -1 && index2 == -1) {
        result = true;
      }
    }
    return result && this.data[this.questionIndex].ifShowAnswerResult;
  }
  private changeTab(item: any) {
    const i = this.tab.findIndex((val: any) => {
      return item === val;
    });
    if (i == -1) {
      this.tab.push(item);
    } else {
      this.tab.splice(i, 1);
    }
  }
  private ifSelected(item: any) {
    let result: any = false;
    const i = this.tab.findIndex((val: any) => {
      return item === val;
    });
    if (i != -1) {
      result = true;
    }
    return result;
  }
  private selectSure() {
    if (this.tab.length == 0) {
      this.$message.warning("请选择四诊知识点分类！");
      return;
    }
    this.data = [];
    this.addOne();
  }
  private cancelSelect() {
    this.$confirm("您确定要重新选择分类么？重新选择后会开始新的练习。", "", {
      customClass: "commonConfirm",
      confirmButtonClass: "iconfont icon-anniu4 confirmSure",
      cancelButtonClass: "iconfont icon-anniu3 confirmCancel",
    })
      .then(() => {
        this.ifShowResult = false;
        this.data = [];
        this.tab = [];
      })
      .catch(() => {
        console.log("取消");
      });
  }
  private async addOne() {
    const loading = this.$loading({
      lock: true,
      text: "加载中……",
      spinner: "el-icon-loading",
      customClass: "loadClass",
      background: "rgba(255, 255, 255, 0.7)",
    });
    let ids: any = [];
    this.data.forEach((ele: any) => {
      ids.push(ele.unit_id);
    });
    const params: any = {
      分类: this.tab,
      已存: ids,
    };
    GetDanxiang(this, params, loading)
      .then(async (res: any) => {
        loading.close();
        this.ifShowResult = true;
        res.ifShowCorrect = false;
        res.ifShowEdit = true;
        res.ifShowAnswer = true;
        res.pic_urls = res.pic_url;
        if (res["类型"] == "单选" || res["类型"] == "判断") {
          res.answer = "";
        } else if (res["类型"] == "多选") {
          res.answer = [];
        }
        this.data.push(res);
        this.questionIndex = this.data.length - 1;
        // 如果支持设备脉，需要调取exe调整设备脉
        if (this.systemInfo.SETTING.iFHasDevicePulse && res["大类"] == "脉") {
          if (this.ifReading) {
            const option = res.options.find(
              (item: any) => item.value === res.correct
            );
            const val: any = option ? option.label : "";
            console.log(val, "control_hand", "start");
            const result = await window.electronMyAPI.changePulse(
              val,
              "control_hand",
              "start"
            );
            console.log(result);
            const loading2 = this.$loading({
              lock: true,
              text: "脉象切换中……",
              spinner: "el-icon-loading",
              customClass: "loadClass",
              background: "rgba(255, 255, 255, 0.7)",
            });
            if (result) {
              this.ifOpen = true;
              loading2.close();
              console.log("返回值：" + result);
            }
          } else {
            console.log("检查", "check_hand", "检查");
            const checkResult = await window.electronMyAPI.changePulse(
              "检查",
              "check_hand",
              "检查"
            );
            console.log(checkResult);
            const loadingCheck = this.$loading({
              lock: true,
              text: "设备检查中……",
              spinner: "el-icon-loading",
              customClass: "loadClass",
              background: "rgba(255, 255, 255, 0.7)",
            });
            if (checkResult) {
              if (checkResult == "success") {
                this.ifReading = true;
                loadingCheck.close();
                console.log("返回值：" + checkResult);
                const option = res.options.find(
                  (item: any) => item.value === res.correct
                );
                const val: any = option ? option.label : "";
                console.log(val, "control_hand", "start");
                const result = await window.electronMyAPI.changePulse(
                  val,
                  "control_hand",
                  "start"
                );
                console.log(result);
                const loading2 = this.$loading({
                  lock: true,
                  text: "脉象切换中……",
                  spinner: "el-icon-loading",
                  customClass: "loadClass",
                  background: "rgba(255, 255, 255, 0.7)",
                });
                if (result) {
                  this.ifOpen = true;
                  loading2.close();
                  console.log("返回值：" + result);
                }
              } else {
                loadingCheck.close();
                alert("设备不存在");
              }
            }
          }
        }
      })
      .catch(() => {
        loading.close();
      });
  }
  private IndexChange(index: any) {
    this.questionIndex = index;
    this.imgIndex = 0;
  }
  private changeSelect(val: any) {
    this.data[this.questionIndex].ifSelect = val;
  }
  private goBefore() {
    if (this.questionIndex == 0) {
      this.$message.warning("已经是第一题了");
      return;
    }
    this.questionIndex--;
    this.imgIndex = 0;
  }
  private goNext() {
    if (this.questionIndex == this.data.length - 1) {
      this.addOne();
    } else {
      this.questionIndex++;
    }
    this.imgIndex = 0;
  }
  private edit() {
    let d: any = JSON.parse(JSON.stringify(this.data[this.questionIndex]));
    delete d.ifShowAnswer;
    delete d.ifShowCorrect;
    delete d.ifShowEdit;
    const loading = this.$loading({
      lock: true,
      text: "加载中……",
      spinner: "el-icon-loading",
      customClass: "loadClass",
      background: "rgba(255, 255, 255, 0.7)",
    });
    SaveDanxiang(this, d, loading)
      .then((res: any) => {
        loading.close();
      })
      .catch(() => {
        loading.close();
      });
  }
  private select(val: any) {
    if (!this.data[this.questionIndex].ifShowEdit) {
      return;
    }
    const item = this.data[this.questionIndex];
    if (item["类型"] == "单选" || item["类型"] == "判断") {
      item.answer = val.value;
    } else if (item["类型"] == "多选") {
      if (!item.answer) {
        item.answer = [];
      } else if (item.answer.length == 0) {
        item.answer.push(val.value);
      } else {
        const index = item.answer.indexOf(val.value);
        if (index == -1) {
          item.answer.push(val.value);
        } else {
          item.answer.splice(index, 1);
        }
      }
    }
    this.data[this.questionIndex] = item;
    this.edit();
    this.$forceUpdate();
  }
  private showResult() {
    // ifShowEdit 是否可以编辑
    // ifShowCorrect 是否显示正确答案
    // ifShowAnswer 是否显示答案
    // ifShowAnswerBtn 是否显示答案按钮
    // ifShowAnswerResult 是否显示答案结果
    this.data[this.questionIndex].ifShowEdit = false;
    this.data[this.questionIndex].ifShowCorrect = true;
    this.data[this.questionIndex].ifShowAnswer = false;
    this.data[this.questionIndex].ifShowAnswerResult = true;
  }
  // // 题目是否作答
  // private ifZuoda() {
  //   let result: any = false;
  //   this.data[this.questionIndex].data.forEach((ele: any) => {
  //     if (ele.type == "单选" && (ele.answer || ele.answer === 0)) {
  //       result = true;
  //     }
  //     if (ele.type == "多选" && ele.answer && ele.answer.length > 0) {
  //       result = true;
  //     }
  //   });
  // }
  private getFenlei() {
    GetSizhenType(this).then((res: any) => {
      this.sizhenTab = [];
      res.forEach((ele: any) => {
        this.sizhenTab.push(ele["名称"]);
      });
    });
  }
  private mounted() {
    this.getFenlei();
  }
  private beforeDestroy(to: any, from: any, next: any) {
    console.log("离开页面");
    if (this.ifOpen) {
      console.log("关闭脉设备");
      console.log("停止", "control_hand", "stop");
      const result = window.electronMyAPI.changePulse(
        "停止",
        "control_hand",
        "stop"
      );
      console.log(result);
    }
  }
}
